import Vue from 'vue';
import api from '@/services/api';

export default new Vue({
	data() {
		let usuario = localStorage.getItem('usuario');

		return {
			params: {},
			usuario: usuario ? JSON.parse(usuario) : null
		};
	},

	watch: {
		usuario: {
			handler() {
				if (this.usuario === undefined || this.usuario === null) {
					localStorage.removeItem('usuario');
				} else {
					localStorage.setItem('usuario', JSON.stringify(this.usuario));

					this.fetchData();
				}
			},

			immediate: true
		}
	},

	methods: {
		async fetchData() {
			let { data } = await api.fetchParams();

			this.params = data;
		}
	}
});